import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const ACCOUNT_GROUP_CORE_FIELDS = gql`
  fragment AccountGroupCoreFields on AccountGroup {
    id
    name
    type
    hiddenAt
  }
`;

export const ACCOUNT_GROUP_FIELDS = gql`
  ${ACCOUNT_GROUP_CORE_FIELDS}
  fragment AccountGroupFields on AccountGroup {
    ...AccountGroupCoreFields
  }
`;

export const ACCOUNT_GROUP = gql`
  ${ACCOUNT_GROUP_FIELDS}
  query AccountGroup($id: ID!) {
    accountGroup(id: $id) {
      ...AccountGroupFields
    }
  }
`;

export const ACCOUNT_GROUPS = gql`
  ${ACCOUNT_GROUP_FIELDS}
  query AccountGroups {
    accountGroups {
      ...AccountGroupFields
    }
  }
`;

const ACCOUNT_GROUP_ARGUMENTS = `
  $name: String!
  $type: String!
`;

const ACCOUNT_GROUP_VARIABLES = `
  name: $name
  type: $type
`;

export const CREATE_ACCOUNT_GROUP = gql`
  ${ACCOUNT_GROUP_CORE_FIELDS}
  mutation CreateAccountGroup (
    ${ACCOUNT_GROUP_ARGUMENTS}
  ) {
    createAccountGroup (
      ${ACCOUNT_GROUP_VARIABLES}
    ) {
      accountGroup {
        ...AccountGroupCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_ACCOUNT_GROUP = gql`
  ${ACCOUNT_GROUP_CORE_FIELDS}
  mutation UpdateAccountGroup (
    $id: ID!
    ${ACCOUNT_GROUP_ARGUMENTS}
  ) {
    updateAccountGroup (
      id: $id
      ${ACCOUNT_GROUP_VARIABLES}
    ) {
      accountGroup {
        ...AccountGroupCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const HIDE_ACCOUNT_GROUP = gql`
  ${ACCOUNT_GROUP_CORE_FIELDS}
  mutation HideAccountGroup ($id: ID!) {
    hideAccountGroup (id: $id) {
      accountGroup {
        ...AccountGroupCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UNHIDE_ACCOUNT_GROUP = gql`
  ${ACCOUNT_GROUP_CORE_FIELDS}
  mutation UnhideAccountGroup ($id: ID!) {
    unhideAccountGroup (id: $id) {
      accountGroup {
        ...AccountGroupCoreFields
      }
      ${ERRORS}
    }
  }
`;
